import cn from 'classnames';
import { Link, type LinkProps } from '@/ui-components/atoms/Link/Link';
import { IconArrow } from '@/assets/icons/IconArrow';
import styles from './breadcrumbs.module.scss';

export interface BreadcrumbsProps {
    items: LinkProps[];
    isDarkTheme?: boolean;
    isWhiteBreadcrumbs?: boolean;
}

const SCHEMA_ORG = {
    BREADCRUMB_LIST: 'https://schema.org/BreadcrumbList',
    LIST_ITEM: 'https://schema.org/ListItem',
} as const;

export function Breadcrumbs({ items, isDarkTheme, isWhiteBreadcrumbs }: BreadcrumbsProps): React.JSX.Element {
    const breadcrumbsWrapper = cn(styles.breadcrumbs, {
        [styles.darkTheme]: isDarkTheme,
        [styles.whiteTheme]: isWhiteBreadcrumbs,
    });

    return (
        <nav className={breadcrumbsWrapper} aria-label="breadcrumb navigation">
            <ol itemScope itemType={SCHEMA_ORG.BREADCRUMB_LIST}>
                {items.map((link, i) => {
                    const isLastItem = i === items.length - 1;
                    const position = i + 1;
                    if (!isLastItem) {
                        return (
                            <li key={link.href} itemProp="itemListElement" itemScope itemType={SCHEMA_ORG.LIST_ITEM}>
                                <Link {...link} itemProp="item" dataCy="atoms-breadcrumbs-nav-link" />
                                <meta itemProp="position" content={String(position)} />
                                <div className={styles.arrowIcon}>
                                    <IconArrow />
                                </div>
                            </li>
                        );
                    }
                    return (
                        <li key={i} itemProp="itemListElement" itemScope itemType={SCHEMA_ORG.LIST_ITEM}>
                            <span itemProp="name">{link.children}</span>
                            <meta itemProp="position" content={String(position)} />
                        </li>
                    );
                })}
            </ol>

            <ol className={styles.mobileList}>
                {items.map((link, i) => {
                    const isSecondLastItem = i === items.length - 2;

                    if (isSecondLastItem) {
                        return (
                            <li key={link.href} className={styles.mobileLink}>
                                <div className={styles.arrowIcon}>
                                    <IconArrow />
                                </div>
                                <Link {...link} itemProp="item" dataCy="atoms-breadcrumbs-nav-link" />
                            </li>
                        );
                    }
                    return null;
                })}
            </ol>
        </nav>
    );
}
